export default __webpack_public_path__ + "static/media/slideshow_step1_en.bced9581.png";